/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Choose_Folder_ButtonInputs */

const en_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Folder`)
};

const fr_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un dossier`)
};

const de_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner auswählen`)
};

const it_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli cartella`)
};

const ru_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите папку`)
};

const es_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir carpeta`)
};

const zh_cn2_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择文件夹`)
};

const ja_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを選択`)
};

const hi_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फोल्डर को चुनो`)
};

const pt_pt2_image_export_choose_folder_button = /** @type {(inputs: Image_Export_Choose_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a pasta`)
};

/**
* | output |
* | --- |
* | "Choose Folder" |
*
* @param {Image_Export_Choose_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_choose_folder_button = /** @type {((inputs?: Image_Export_Choose_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Choose_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_choose_folder_button(inputs)
	if (locale === "de") return de_image_export_choose_folder_button(inputs)
	if (locale === "it") return it_image_export_choose_folder_button(inputs)
	if (locale === "ru") return ru_image_export_choose_folder_button(inputs)
	if (locale === "es") return es_image_export_choose_folder_button(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_choose_folder_button(inputs)
	if (locale === "ja") return ja_image_export_choose_folder_button(inputs)
	if (locale === "hi") return hi_image_export_choose_folder_button(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_choose_folder_button(inputs)
	return en_image_export_choose_folder_button(inputs)
});